// Import Swiper styles
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';

import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Thumbs } from 'swiper/core';

import { PRODUCT_IMAGE_SIZE } from 'Lib/constants/image';
import SiteImage from 'Components/Common/SiteImage';
import { cloudinaryLoader } from 'functions';
import { useState } from 'react';

SwiperCore.use([Navigation, Pagination, Thumbs]);

const ProductSlide = ({ classNames, data }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  return (
    <>
      <Swiper
        className={classNames}
        spaceBetween={ 10}
        slidesPerView={1}
        speed={500}
        pagination={{
          "type": "fraction"
        }}
        thumbs={{ swiper: thumbsSwiper }}>
        {data.map((image, index) => (
          <SwiperSlide key={index}>
            <SiteImage
              width={PRODUCT_IMAGE_SIZE.width}
              height={PRODUCT_IMAGE_SIZE.height}
              alt={image?.altText}
              src={image?.cloudinaryResource?.url_suffix || image?.sourceUrl}
              layout="responsive"
              loader={image?.cloudinaryResource ? cloudinaryLoader : ''}
              priority
            />
          </SwiperSlide>
        ))}
      </Swiper>

      <Swiper
        onSwiper={setThumbsSwiper}
        spaceBetween={10}
        slidesPerView={5}
        freeMode={true}
        className="mt-2 opacity-80">
        {data.map((image, index) => (
          <SwiperSlide key={index}>
            <SiteImage
              width={100}
              height={100}
              alt={image?.altText}
              src={image?.thumb}
              layout="responsive"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};

export default ProductSlide;
